export class ActivationRequiredError extends Error {
  constructor(detail) {
    super(detail);
    this.name = "ActivationRequiredError";
    this.detail = detail;
  }
}

export class AccountLockedError extends Error {
  constructor(detail) {
    super(detail);
    this.name = "AccountLockedError";
    this.detail = detail;
  }
}

export function getApiErrorDetail(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg || item).join(", ");
  }
  return err?.message || "Something went wrong. Please try again.";
}
